// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles__icon___KsAaK"};